"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getMaskOptions", {
    enumerable: true,
    get: function() {
        return getMaskOptions;
    }
});
var _kit = require("@maskito/kit");
var getMaskOptions = function(param) {
    var mask = param.mask, _param_prefix = param.prefix, prefix = _param_prefix === void 0 ? "" : _param_prefix, _param_postfix = param.postfix, postfix = _param_postfix === void 0 ? "" : _param_postfix, _param_caretPositioning = param.caretPositioning, caretPositioning = _param_caretPositioning === void 0 ? true : _param_caretPositioning;
    var plugins = [];
    var postprocessors = [];
    var handleEmptyInputAffixes = function(param) {
        var value = param.value, selection = param.selection;
        var trimmedInput = value;
        if (prefix && trimmedInput.startsWith(prefix)) {
            trimmedInput = trimmedInput.substring(prefix.length);
        }
        if (postfix && trimmedInput.endsWith(postfix)) {
            trimmedInput = trimmedInput.substring(0, trimmedInput.length - postfix.length);
        }
        var newValue = trimmedInput.trim() ? value : "";
        return {
            value: newValue,
            selection: selection
        };
    };
    if (caretPositioning) {
        var calculateCaretEnd = function(value) {
            return Math.max(prefix.length, value.length - postfix.length);
        };
        plugins.push((0, _kit.maskitoCaretGuard)(function(value) {
            return [
                prefix.length,
                calculateCaretEnd(value)
            ];
        }));
    }
    if (prefix) postprocessors.push((0, _kit.maskitoPrefixPostprocessorGenerator)(prefix));
    if (postfix) postprocessors.push((0, _kit.maskitoPostfixPostprocessorGenerator)(postfix));
    postprocessors.push(handleEmptyInputAffixes);
    return {
        mask: mask,
        postprocessors: postprocessors,
        plugins: plugins
    };
};
